import React, { useState } from 'react';

const SubscriptionForm = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(null);

  const validateEmail = (email) => {
    // Robust client-side validation using a regular expression
    // This checks for a common email format (e.g., user@domain.com)
    // While this provides a good user experience by catching common errors early,
    // it is crucial to understand that client-side validation is NOT a security measure.
    // Malicious users can bypass client-side checks.
    // Server-side validation is the critical security layer to prevent
    // invalid data or injection attacks from reaching the backend and database.
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(''); // Clear previous messages
    setIsSuccess(null); // Reset success state

    if (!validateEmail(email)) {
      setMessage('Vänligen ange en giltig e-postadress.');
      setIsSuccess(false);
      return;
    }

    try {
      const response = await fetch('https://grandeplatform.eu.pythonanywhere.com/api/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (response.status === 201) {
        setMessage('Prenumerationen lyckades!');
        setIsSuccess(true);
        setEmail(''); // Clear email input on success
      } else if (response.status === 400) {
        const errorData = await response.json();
        setMessage(errorData.message || 'Prenumerationen misslyckades: Ogiltig förfrågan.');
        setIsSuccess(false);
      } else {
        setMessage('Prenumerationen misslyckades: Ett oväntat fel inträffade.');
        setIsSuccess(false);
      }
    } catch (error) {
      console.error('Subscription API error:', error);
      setMessage('Prenumerationen misslyckades: Kunde inte ansluta till servern.');
      setIsSuccess(false);
    }
  };

 

  return (
    <div className="bg-gray-800 p-6 rounded-lg shadow-xl max-w-md mx-auto border border-gray-700">
      <h3 className="text-xl font-semibold text-white mb-4 text-center">Håll dig uppdaterad!</h3>
      <p className="text-gray-300 mb-4 text-center">Prenumerera på vårt nyhetsbrev för att få de senaste nyheterna och erbjudandena direkt till din inkorg.</p>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
    <input
      type="email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      placeholder="Ange din e-postadress"
      className="flex-grow px-4 py-2 bg-gray-700 border border-gray-600 text-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
      required
      />
        <button
          type="submit"
          className="bg-red-700 hover:bg-red-800 text-white font-bold py-2 px-4 rounded-md transition duration-150"
        >
          Prenumerera
        </button>
      </form>
      {message && (
    <p className={`mt-4 text-center ${isSuccess ? 'text-green-600' : 'text-red-600'}`}>
      {message}
    </p>
  )}
    </div>
  );
};

export default SubscriptionForm;